import React from 'react';
import { useSelector } from 'react-redux'
import { Card, CardBody, CardHeader, Label, Input, Button } from 'reactstrap';

import Switch from 'react-switch'
import './OnOff.scss'

type Props = {
  label: string;
  checked: boolean;
  disabled?: boolean;

  onChange: (checked: boolean) => void;
}
const OnOff = (props: Props) => {
  return (
    <div className="on-off">
      <Switch
        checked={props.checked}
        onChange={props.onChange}
        />
      <div className="on-off-txt">{props.label}</div>
    </div>
  )
}

export default OnOff;
